import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Home.module.css";
import config from "../../config/api.config";
const Home = ({ setvideo }) => {
  const [videos, setVideos] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const observer = useRef();
  const navigate = useNavigate();

  // Scroll to top only on initial load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fetchVideos = useCallback(
    async (pageNum) => {
      setLoading(true);
      try {
        const response = await fetch(
          `/api/videos/getpublicvideos?page=${pageNum}&limit=${10}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        const data = await response.json();

        if (data.error) {
          navigate("/login");
          return;
        }

        if (data.videos.length === 0) {
          setHasMore(false);
        } else {
          setVideos((prev) =>
            pageNum === 1 ? data.videos : [...prev, ...data.videos]
          );
          setPage(pageNum);
        }
      } catch (error) {
        console.error("Error fetching videos:", error);
      } finally {
        setLoading(false);
      }
    },
    [navigate]
  );

  useEffect(() => {
    fetchVideos(1);
  }, [fetchVideos]);

  // Setup intersection observer for infinite scroll
  const lastVideoElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          fetchVideos(page + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, hasMore, page, fetchVideos]
  );

  const handleVideoClick = (video) => {
    setvideo(video);
    navigate(`/player?v=${video.videoId}`);
  };

  return (
    <div className={styles.homeContainer}>
      <div className={styles.videoGrid}>
        {videos.map((video, index) => (
          <div
            key={video.videoId}
            className={styles.videoCard}
            onClick={() => handleVideoClick(video)}
            ref={index === videos.length - 1 ? lastVideoElementRef : null}
          >
            <img
              src={`${config.ThumbUrl}/videos/${video.videoId}/thumbnail.jpg`}
              alt={video.title}
              className={styles.thumbnail}
            />
            <div className={styles.videoInfo}>
              <h3>{video.title}</h3>
              {/* <p className={styles.channelName + " removepadding"}>
                {video.username || "Unknown"}
              </p> */}
              <div className={styles.videoStats}>
                <p>{video.username || "Unknown"}</p>
                <p>{video.views} views</p>
                {/* <p>{new Date(video.createdAt).toLocaleDateString()}</p> */}
                {(() => {
                  const createdDate = new Date(video.createdAt);
                  const now = new Date();
                  const diffMs = now - createdDate;
                  const diffHrs = Math.floor(diffMs / (1000 * 60 * 60));
                  const diffMins = Math.floor(
                    (diffMs % (1000 * 60 * 60)) / (1000 * 60)
                  );

                  if (
                    createdDate.toLocaleDateString() ===
                    now.toLocaleDateString()
                  ) {
                    return diffHrs > 0
                      ? `${diffHrs} hours ${diffMins} minutes ago`
                      : `${diffMins} minutes ago`;
                  }
                  return createdDate.toLocaleDateString();
                })()}
              </div>
            </div>
          </div>
        ))}
      </div>
      {loading && <div className={styles.loading}>Loading more videos...</div>}
      {!hasMore && videos.length > 0 && (
        <div className={styles.endMessage}>No more videos to load</div>
      )}
    </div>
  );
};

export default Home;
